import axios from 'axios'
export default {
  uploadImages ({state, commit}, input) {
    let http = axios.create({
      timeout: 200000,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    let data = new FormData()
    data.append('userfile', input)
    http.post('http://homologacao2.hotvia.com.br/imagens/index.php', data).then((response) => {
      commit('addFoto', response.data)
    })
  },
  deleteImages ({state, commit}, input) {
    let http = axios.create({
      timeout: 200000,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    let data = new FormData()
    data.append('remove', input)
    http.post('http://homologacao2.hotvia.com.br/imagens/index.php', data).then((response) => {
      commit('removeFoto', response.data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/shared/actions.js